import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { CreatorsAnchors } from '../../../../store/ducks/anchors';

import api from '../../../../services/api';
import { getPermissions } from '../../../../services/auth';
import { dddTel } from '../../../../utils/functions';
import { useHistory } from 'react-router';

import Render from './EditRender';

function Edit({ id }) {
  const history = useHistory();

  const [inputs, setInputs] = useState({});
  const [getLoading, setLoading] = useState(true);
  const [getCargos, setCargos] = useState([]);

  const dispatch = useDispatch();

  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
  };

  const getInfoForForm = async () => {
    try {
      const findAncorasContato = await api.get(`AncorasContatos/ConsultarId?id=${id}`);
      const findCargos = await api.get('Cargos/Consultar?status=Ativo');

      const responseForInputs = findAncorasContato.data.resposta;

      let telefoneVazio1 = '';
      let telefoneVazio2 = '';

      if (responseForInputs.ddd1 !== '') {
        telefoneVazio1 = `(${responseForInputs.ddd1}) `;
      }
      if (responseForInputs.ddd2 !== '') {
        telefoneVazio2 = `(${responseForInputs.ddd2}) `;
      }

      setInputs({
        ...responseForInputs,
        telefone1: responseForInputs.telefone1 && `${telefoneVazio1}${responseForInputs.telefone1}`,
        telefone2: responseForInputs.telefone2 && `${telefoneVazio2}${responseForInputs.telefone2}`,
      });
      setCargos(findCargos.data.resposta);
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.');
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    dispatch(CreatorsAnchors.changeLastGrid('ancoras-contatos'));

    const permissions = getPermissions({ moduloId: 1344, permissao: 'Consultar' });

    if (permissions) {
      getInfoForForm();
    } else {
      history.push('/app');
    }
  }, []);

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault();
      setLoading(true);
      try {
        const response = await api.put('AncorasContatos', {
          ...inputs,
          ancoraContatoId: parseInt(id),
          cargoId: parseInt(inputs.cargoId),
          ancoraId: parseInt(inputs.ancoraId),
          ddd1: dddTel(inputs.telefone1, 'ddd'),
          ddd2: dddTel(inputs.telefone2, 'ddd'),
          telefone1: dddTel(inputs.telefone1),
          telefone2: dddTel(inputs.telefone2),
        });
        if (response.data.status !== 'Inconsistencia') {
          toast.success('Contato alterado com sucesso!');
        } else {
          if (response.data.resposta[0].key) {
            response.data.resposta.map((resposta) => {
              toast.error(resposta.key + ' - ' + resposta.message);
              return null;
            });
          } else {
            toast.error('Não foi possível alterar o contato!');
          }
        }
      } catch (err) {
        if (err.response.data && err.response.data.resposta[0]) {
          toast.error(err.response.data.resposta[0].message);
        } else {
          toast.error('Detectamos um problema interno! tente novamente em instantes.');
        }
      }
      setLoading(false);
    }
  };

  return (
    <Render
      inputs={inputs}
      getLoading={getLoading}
      handleInputChange={handleInputChange}
      getCargos={getCargos}
      onSubmit={handleSubmit}
    />
  );
}

export default Edit;
